import { render, staticRenderFns } from "./SettingsLocalisationRegions.vue?vue&type=template&id=7b6133ff&"
import script from "./SettingsLocalisationRegions.vue?vue&type=script&lang=ts&"
export * from "./SettingsLocalisationRegions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports